// extracted by mini-css-extract-plugin
export default {"Tile":"gBABxIGbxR2xPvGw4anw","AppDescription":"c0Drh705acEdAJzC7eix","BrandImageContainer":"B3vS8JdCJZ3HCYxbxtzZ","BrandImage":"ljp_KxycCcjzYfqxHyS3"};